// extracted by mini-css-extract-plugin
export default {"dropdown":"style_dropdown__7DYes","settingsButton":"style_settingsButton__CmdIr","avatar":"style_avatar__tb85Q","userMenu":"style_userMenu__bmVo+"};